export type Department = 'deck' | 'engine' | 'unknown';

const ENGINE_RE = /\bengineer\b|\bmeo\b|\belectro.techni|\beto\b|\belectrician\b|engine\s+cadet/i;
const DECK_RE   = /\bmaster\b|\bmate\b|officer.*watch|\boow\b|\bnavigat|\bdeck\b|deck\s+cadet|\bcadet\b/i;

export function getDepartment(discipline: string, rank = ''): Department {
  const text = `${discipline} ${rank}`;
  if (ENGINE_RE.test(text)) return 'engine';
  if (DECK_RE.test(text))   return 'deck';
  return 'unknown';
}

export type RequiredCert = {
  label: string;
  patterns: RegExp[];
};

export const COMMON_REQUIRED: RequiredCert[] = [
  { label: 'Basic Safety Training (BST)',   patterns: [/\bbst\b/i, /basic safety training/i] },
  { label: 'PSCRB',                         patterns: [/\bpscrb\b/i, /proficiency.*survival craft/i, /survival craft/i] },
  { label: 'Advanced Fire Fighting (AFF)',  patterns: [/\baff\b/i, /advanced fire.?fighting/i] },
  { label: 'Medical First Aid (MFA)',       patterns: [/\bmfa\b/i, /medical first aid/i] },
  { label: 'Medical Fitness (ENG1)',        patterns: [/\beng1\b/i, /medical fitness/i, /fitness certificate/i, /medical examination/i] },
  { label: 'Crowd Management',             patterns: [/crowd management/i] },
  { label: 'CDC',                          patterns: [/\bcdc\b/i, /continuous discharge/i] },
  { label: 'Passport',                     patterns: [/\bpassport\b/i] },
];

export const DECK_REQUIRED: RequiredCert[] = [
  { label: 'GMDSS / GOC',                  patterns: [/\bgmdss\b/i, /\bgoc\b/i, /global maritime distress/i] },
  { label: 'ARPA (Operational)',            patterns: [/\barpa\b/i, /radar plotting/i] },
  { label: 'ECDIS',                        patterns: [/\becdis\b/i, /electronic chart/i] },
  { label: 'Bridge Resource Management',   patterns: [/\bbrm\b/i, /bridge resource management/i] },
  { label: 'Ship Security Officer (SSO)',  patterns: [/\bsso\b/i, /ship security officer/i] },
];

export const ENGINE_REQUIRED: RequiredCert[] = [
  { label: 'Engine Resource Management',   patterns: [/\berm\b/i, /engine resource management/i] },
  { label: 'High Voltage (HV)',            patterns: [/\bhv\b/i, /high voltage/i] },
  { label: 'MARPOL',                       patterns: [/\bmarpol\b/i, /pollution prevention/i] },
];

export const DEPT_LABEL: Record<Department, string> = {
  deck:    'Deck',
  engine:  'Engine',
  unknown: 'General',
};

export function getRequiredCerts(dept: Department): RequiredCert[] {
  if (dept === 'deck')   return [...COMMON_REQUIRED, ...DECK_REQUIRED];
  if (dept === 'engine') return [...COMMON_REQUIRED, ...ENGINE_REQUIRED];
  return COMMON_REQUIRED;
}
